import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { PageTitle } from './PageTitle';
import PlayerTag from './PlayerTag';

import { useOnline } from '../services/useOnline';
import { useApplication } from '../AppContext';

export const RoomTypes = {
	Find: 'Find a Game',
	Create: 'Private Room',
};

// const player = {
// 	imageURL: 'assets/Avatars/vv/AvatarVV_0071.png',
// 	name: 'Player Name',
// 	rank: 0,
// 	rating: 100,
// 	inviteCode: '213904',
// };

const OnlineMenu = () => {

	const { t } = useTranslation();
	const isOnline = useOnline();
	const app = useApplication();

	const navigate = React.useCallback((event, page) => {
		event.preventDefault();
		app.navigate(page);
	}, [app]);

	const menuOptions = React.useMemo(() => {
		return Object.entries(RoomTypes).map(([name, title]) => {
			return (
				<li key={name}>
					<a href={`#Online/${name}`} className="button buttonEasy" onClick={event => navigate(event, `Online/${name}`)}>
						{t(title)}
					</a>
				</li>
			);
		});
	}, [t, navigate]);

	const content = React.useMemo(() => {
		if (!isOnline) {
			return (
				<>
					<div>{t('You appear to be offline.')}</div>
					<div>{t('Please check your connection.')}</div>
				</>
			);
		}

		return (
			<ul className="buttonList">
				{menuOptions}
				<li>
					<PlayerTag showOnline />
				</li>
			</ul>
		);

	}, [isOnline, menuOptions, t]);

	return (

		<div id="OnlineMenu" className="page1">
			<div className="wrapper">
				<PageTitle>
					<h1>{t('Online')}</h1>
				</PageTitle>
				{content}

			</div>
		</div>
	);
};

export default React.memo(OnlineMenu);
